"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @function occupationReducer
 * @param state
 * @param action
 * @returns occupation state
 */
var occupation_1 = require("../../actions/occupation");
function occupationReducer(state, action) {
    if (state === void 0) { state = occupation_1.DefaultState; }
    switch (true) {
        case action.type.includes(occupation_1.BUILD_OCCUPATION): {
            var newState = state;
            newState = action.occupationData;
            return newState;
        }
        case action.type.includes(occupation_1.CHANGE_OCCUPATION): {
            var newState = state;
            newState.selectedOccupation = action.selectedOccupation;
            return newState;
        }
        default:
            return state;
    }
}
exports.default = occupationReducer;
